module.exports = __webpack_public_path__ + "static/img/service_introduce_5766_zh.330a4f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_5766_zh.png
// module id = WsUC
// module chunks = 34